// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"Compare_thecomp__hupG1"};